"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfigConsumer = void 0;
Object.defineProperty(exports, "ConfigContext", {
  enumerable: true,
  get: function get() {
    return _context.ConfigContext;
  }
});
exports.default = exports.ProviderChildren = exports.ConfigProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _context = require("./context");
var _utils = _interopRequireDefault(require("./utils"));
var _locale = _interopRequireDefault(require("../locale"));
var _excluded = ["children", "locale", "parentContext", "getPopupContainer"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ProviderChildren = exports.ProviderChildren = function ProviderChildren(props) {
  var children = props.children,
    locale = props.locale,
    parentContext = props.parentContext,
    getPopupContainer = props.getPopupContainer,
    restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var getPrefixCls = _react.default.useCallback(function (suffixCls, customizePrefixCls) {
    var prefixCls = props.prefixCls;
    if (customizePrefixCls) return customizePrefixCls;
    var mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
    return suffixCls ? "".concat(mergedPrefixCls, "-").concat(suffixCls) : mergedPrefixCls;
  }, [parentContext.getPrefixCls, props.prefixCls]);
  var getIconPrefixCls = _react.default.useCallback(function (customizeIconPrefixCls) {
    if (customizeIconPrefixCls) return customizeIconPrefixCls;
    var iconPrefixCls = props.iconPrefixCls;
    return iconPrefixCls || (parentContext === null || parentContext === void 0 ? void 0 : parentContext.getIconPrefixCls());
  }, [parentContext === null || parentContext === void 0 ? void 0 : parentContext.getIconPrefixCls, props.iconPrefixCls]);
  var config = _objectSpread(_objectSpread(_objectSpread({}, parentContext), restProps), {}, {
    locale: locale,
    getPrefixCls: getPrefixCls,
    getIconPrefixCls: getIconPrefixCls,
    getPopupContainer: getPopupContainer !== null && getPopupContainer !== void 0 ? getPopupContainer : parentContext.getPopupContainer
  });
  var memoedConfig = (0, _utils.default)(function () {
    return config;
  }, config, function (prevConfig, currentConfig) {
    var prevKeys = Object.keys(prevConfig);
    var currentKeys = Object.keys(currentConfig);
    return prevKeys.length !== currentKeys.length || prevKeys.some(function (key) {
      return prevConfig[key] !== currentConfig[key];
    });
  });
  var childNode = children;
  /*
   * Additional Form provider
   * let validateMessages;
   */
  if (locale) {
    childNode = /*#__PURE__*/_react.default.createElement(_locale.default, {
      locale: locale
    }, childNode);
  }
  return /*#__PURE__*/_react.default.createElement(_context.ConfigContext.Provider, {
    value: memoedConfig
  }, childNode);
};
var ConfigProvider = exports.ConfigProvider = function ConfigProvider(props) {
  var context = (0, _react.useContext)(_context.ConfigContext);
  return /*#__PURE__*/_react.default.createElement(ProviderChildren, _objectSpread({
    parentContext: context
  }, props));
};
ConfigProvider.ConfigContext = _context.ConfigContext;
ConfigProvider.config = _context.setDefaultConfig;
/**
 * @deprecated 请使用 useContext 代替
 */
var ConfigConsumer = exports.ConfigConsumer = _context.ConfigContext.Consumer;
var _default = exports.default = ConfigProvider;